import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container"]

  connect() {
    this.handleSubmitStart = this.handleSubmitStart.bind(this)
    this.handleSubmitEnd = this.handleSubmitEnd.bind(this)
    
    document.addEventListener("turbo:submit-start", this.handleSubmitStart)
    document.addEventListener("turbo:submit-end", this.handleSubmitEnd)
  }

  disconnect() {
    document.removeEventListener("turbo:submit-start", this.handleSubmitStart)
    document.removeEventListener("turbo:submit-end", this.handleSubmitEnd)
  }

  handleSubmitStart(event) {
    const target = event.target[0];
    const targetOne = event.target[1];
    if (target.classList.contains("favorite-button") || targetOne.classList.contains("mark-notification-as-read")) return;
    
    this.containerTarget.classList.remove("hidden");
  }

  handleSubmitEnd() {
    this.containerTarget.classList.add("hidden")
  }

  hide() {
    this.containerTarget.classList.add('hidden')
  }

  show() {
    this.containerTarget.classList.remove('hidden')
  }
} 